import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { api } from '../services/api';
import { useProbeData } from '../contexts/RegionContext';
import { adaptApplyUrl } from '../utils/routing';

export default function ShortUrlRedirect() {
  const { positionUuid } = useParams<{ positionUuid: string }>();
  const navigate = useNavigate();
  const probeData = useProbeData<{ apply_url?: string }>();

  useEffect(() => {
    if (!positionUuid) {
      navigate('/404', { replace: true });
      return;
    }

    // Use probe data if available (region resolution already fetched this position)
    if (probeData?.apply_url) {
      const pathname = new URL(probeData.apply_url).pathname;
      navigate(adaptApplyUrl(pathname), { replace: true });
      return;
    }

    api.get(`/hiring/positions/${positionUuid}`)
      .then((response) => {
        const applyUrl: string = response.data.apply_url;
        if (!applyUrl) {
          navigate('/404', { replace: true });
          return;
        }
        const pathname = new URL(applyUrl).pathname;
        navigate(adaptApplyUrl(pathname), { replace: true });
      })
      .catch(() => {
        navigate('/error', { replace: true });
      });
  }, [positionUuid, navigate, probeData]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="w-8 h-8 border-4 border-gray-300 border-t-gray-600 rounded-full animate-spin" />
    </div>
  );
}
